import { render } from "./Carousel.vue?vue&type=template&id=2df6b902"
import script from "./Carousel.vue?vue&type=script&lang=js"
export * from "./Carousel.vue?vue&type=script&lang=js"

import "./Carousel.vue?vue&type=style&index=0&id=2df6b902&lang=css"
script.render = render

export default script